export default (phone = '', identifier = null) => ({

    identifier: identifier,
    phone: phone,

    clickToCall: {
        ['x-on:click']() {

            if (typeof window.gtag === 'function') {
                window.gtag('event', 'ClickToCall', {});
            }

            if (typeof window.fbq === 'function') {
                window.fbq('trackSingle', '1117998811575937', 'Phone', {
                    content_name: 'Phone Click: ' + identifier + ' (' + phone + ')',
                });
            }

            if (typeof adroll !== 'undefined' && typeof adroll.track === 'function') {
                adroll.track("pageView", {
                    segment_name: "346a2f0f"
                });
            }
        },
    },
});
